import React from 'react';
import MultiLangLabelField from "./MultiLangLabelField.mjs";
import "./RemediationField.css";
import {InputGroup, InputGroupText, Label} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";
import IntervalTypeField from "./IntervalTypeField.mjs";
import appLib from "../../libs/appLib.mjs";

const prefix = 'RemediationField';

const RemediationField = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { data: props.value || {} };
		this.setValue = this.setValue.bind(this);
	}
	/**
	 * @param {Event|HTMLFormElement|string} field
	 * @param {string|number|null} [value]
	 * @return {void}
	 */
	setValue = (field, value ) => {
		if ( field?.target ) field = field.target;
		if ( field?.name ) {
			value = field.value;
			field = field.name;
		}
		let data = this.state.data;
		if ( ! value || (typeof value === "string" && ! value.trim() ) ) {
			delete data[field];
		} else {
			data[field] = value;
		}
		this.setState({ data: data }, ()=>{
			this.props.onChange( data?.text ? data : undefined );
		});
	}
	render() {
		return(
			<div className={prefix}>
				<MultiLangLabelField
					value={ this.state.data.text || {} }
					langs={ this.props.langs }
					long={true}
					onChange={ n => { this.setValue( 'text', n ) }}
				/>
				<div>
					<InputGroup>
						<InputGroupText>
							<Label>
								<TextLabel value={"Cost"} />
							</Label>
						</InputGroupText>
						<InputGroupText className={"flex-grow-1 clear"}>
							<IntervalTypeField
								values={ appLib.costValues() }
								value={ this.state.data.cost }
								onChange={ n => { this.setValue( 'cost', n ) } }
							/>
						</InputGroupText>
					</InputGroup>
					<InputGroup>
						<InputGroupText>
							<Label>
								<TextLabel value={"Difficulty"} />
							</Label>
						</InputGroupText>
						<InputGroupText className={"flex-grow-1 clear"}>
							<IntervalTypeField
								values={ appLib.difficultyValues() }
								value={ this.state.data.difficulty }
								onChange={ n => { this.setValue( 'difficulty', n ) } }
							/>
						</InputGroupText>
					</InputGroup>
				</div>
			</div>
		)
	}
}

export default RemediationField;